<div class="dialog">

  <app-mobile-session-view *ngIf="session"
                           [organization]="organization"
                           [session]="session"
                           [athleteUser]="athleteUser"
                           [sessionId]="session.id!"
  >
    <div *ngIf="timeslotFormGroup" [formGroup]="timeslotFormGroup" class="timeslot-form-group">
      <mat-form-field [hintLabel]="'date_format_hint' | translate" class="timeslot-field">
        <mat-label class="required">{{ 'Date' | translate }}</mat-label>
        <input matInput #date formControlName="date" [matDatepicker]="timeslotDatepicker" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="timeslotDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #timeslotDatepicker startView="month"></mat-datepicker>
        <mat-error *ngIf="f['date'].errors && f['date'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
      </mat-form-field>
      <div class="timeslot-time-group">
        <mat-form-field class="timeslot-field ">
          <mat-label class="required">{{ 'TimeStart' | translate }}</mat-label>
          <input matInput #timeStart formControlName="timeStart" autocomplete="off">
          <mat-error *ngIf="f['timeStart'].errors && f['timeStart'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
          <mat-error *ngIf="f['timeStart'].errors && f['timeStart'].errors?.['invalidTime'] && !f['timeStart'].errors?.['required']">{{ 'Time_invalid' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field class="timeslot-field timeslot-time-end-field">
          <mat-label class="required">{{ 'TimeEnd' | translate }}</mat-label>
          <input matInput #timeEnd formControlName="timeEnd" autocomplete="off" class="timeslot-time-end-field">
        </mat-form-field>
      </div>
      <mat-error class="save-error" *ngIf="error">{{ error | translate }}</mat-error>
    </div>
  </app-mobile-session-view>


  <!--  close button and end session button -->
  <div class="bottom-buttons">
    <button
      mat-raised-button
      mat-dialog-close
      color="primary"
      class="large-button">
      {{ 'Close' | translate}}
    </button>
    <button
      mat-raised-button
      color="accent"
      (click)="onSaveClicked()"
      class="large-button">
      {{ 'Save' | translate}}
    </button>
  </div>

</div>
